(function () {
  'use strict';

  var root = document.getElementById('SoulyshinePupPopup');
  var teaser = document.getElementById('SoulyshinePupTeaser');
  if (!root || !teaser || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';
  var IMG = window.SoulyshineThreeDoorImages || {};
  var S = { view: window.innerWidth < 720 ? 'm' : 'd', step: 'door', door: null, pick: null, who: 'me', email: '', err: '', phone: '', phoneErr: '', smsOptIn: false, copied: false, expiresAt: 0, code: 'WELCOME10', optedIn: false, submitting: false };

const SITE = 'https://www.soulyshine.com';
const STAR = '<path fill="currentColor" d="M50 0l9 21 22-8-8 22 21 9-21 9 8 22-22-8-9 21-9-21-22 8 8-22-21-9 21-9-8-22 22 8z"/>';
const PAW = c => `<g fill="${c}"><ellipse cx="32" cy="42" rx="14" ry="12"/><circle cx="14" cy="26" r="6"/><circle cx="25" cy="15" r="6"/><circle cx="39" cy="15" r="6"/><circle cx="50" cy="26" r="6"/></g>`;
const ARROW = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
const BACK = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 12H5M11 6l-6 6 6 6"/></svg>';

const DOOR = [
  {id:'dog', name:'My dog', cap:'200+ breeds in 4 signature poses', color:'#FFD45C', imgs:['zoom'], tag:'Most loved'},
  {id:'cat', name:'My cat', cap:'Every breed, every attitude', color:'#7FDCC4', imgs:['judge']},
  {id:'passion', name:'My people & passions', cap:'Nurses, makers, travelers, grandmas and more', color:'#FFB5D3', imgs:['nurse','coffee','travel']}
];
const DOG = [
  {id:'paw', name:'The Paw-Giver', cap:'Will shake for snacks.', color:'#FF9C82', product:'My Baby', bubble:'High five?', verdict:'Polite, persuasive, and fully aware the paw works every time.', url:SITE+'/products/200-dog-breeds-forever-my-baby-charm'},
  {id:'gaze', name:'The Velcro Stare', cap:'Follows you to the bathroom.', color:'#7FDCC4', product:'The Way You Look at Me', bubble:'u r my world', verdict:'Ten out of ten eye contact. Zero personal space. Pure devotion.', url:SITE+'/products/200-dog-breeds-the-way-you-look-at-me-every-day-charm'},
  {id:'nap', name:'The Nap Champion', cap:'16 hours a day. No apologies.', color:'#C3B6FF', product:'Sleeping Dog', bubble:'zzz', verdict:'Professional couch tester. Snores in a very specific key.', url:SITE+'/products/200-dog-breeds-sleeping-dog-charm-polyester-cord-bracelet-set'},
  {id:'zoom', name:'The Zoomies Machine', cap:'0 to 100 at 9pm. Daily.', color:'#FFD45C', product:'Happy Pup', bubble:'ZOOM!', verdict:'Fast, loud, and absolutely worth every lap of the living room.', url:SITE+'/products/200-dog-breeds-happy-pup-charm'}
];
const CAT = [
  {id:'strut', name:'The Strut', cap:'Walks in like they own the place.', color:'#9ED2FF', product:'Cat Breed', bubble:'I own this', verdict:'Tail up, zero rush, total confidence. Every room is their runway.', url:SITE+'/products/cat-breed-charms'},
  {id:'judge', name:'The Quiet Judge', cap:'Has opinions. Shares them by staring.', color:'#FFB5D3', product:'Always Close', bubble:'…really?', verdict:'Sits perfectly still and sees everything. Loves you on their own terms.', url:SITE+'/products/seated-cat-breed-charms'}
];
const PASS = [
  {id:'work', name:'Proud of what I do', cap:'Nurses, stylists, teachers', color:'#FF9C82', result:'The Everyday Hero', shop:'Start with Nurse & Healthcare', verdict:'You show up for everyone. Here is something that shows up for you.', handle:'nurse-healthcare-charms',
    charms:[['nurse','Nurse & Healthcare','nurse-healthcare-charms'],['hairstylist','Hairstylists','hairstylist-charms'],['school','School Days','school-days-charms'],['science','Science & Tech','science-technology-charms']]},
  {id:'makers', name:'Made by hand', cap:'Crochet, sewing, baking', color:'#FFD45C', result:'The Maker', shop:'Start with Crochet & Knitting', verdict:'Yarn in your bag, flour on your sleeve. These charms get it.', handle:'fiber-arts-charms',
    charms:[['crochet','Crochet & Knitting','fiber-arts-charms'],['sewing','Sewing & Quilting','sewing-quilting-charms'],['coffee','Coffee & Baking','coffee-baking-charms'],['arts','Arts & Crafts','arts-crafts-charms']]},
  {id:'outdoors', name:'Out there', cap:'Travel, ocean, horses', color:'#7FDCC4', result:'The Wanderer', shop:'Start with Travel & Adventure', verdict:'Happiest somewhere with a view. Carry your favorite place with you.', handle:'travel-adventure-charms',
    charms:[['travel','Travel & Adventure','travel-adventure-charms'],['ocean','Ocean & Sea','ocean-sea-charms'],['horse','Horse Lovers','horse-lovers-charms'],['roadtrip','Vintage Road Trip','vintage-road-trip-charms']]},
  {id:'family', name:'My people', cap:'Babies, home, milestones', color:'#FFB5D3', result:'The Heart of the Family', shop:'Start with Baby & First Steps', verdict:'First steps, big birthdays, and the people who feel like home.', handle:'baby-first-steps-charms',
    charms:[['baby','Baby & First Steps','baby-first-steps-charms'],['home','Home & Family Roots','home-family-roots-charms'],['milestones','Milestones','milestones-celebrations-charms'],['longdistance','Long Distance','long-distance-connection-charms']]},
  {id:'believe', name:'What I believe', cap:'Faith, zodiac, self-love', color:'#C3B6FF', result:'The Kindred Spirit', shop:'Start with Faith & Guardian', verdict:'Faith, stars, and a little self-love. Wear what you believe.', handle:'faith-guardian-charms',
    charms:[['faith','Faith & Guardian','faith-guardian-charms'],['celestial','Celestial & Zodiac','celestial-zodiac-charms'],['selflove','Self-Love','self-love-empowerment-charms'],['newbeginnings','New Beginnings','new-beginnings-charms']]},
  {id:'fun', name:'Just for fun', cap:'Music, books, spooky', color:'#9ED2FF', result:'The Main Character', shop:'Start with Music & Dance', verdict:'Your playlist, your books, your fandom. Your thing, worn every day.', handle:'music-dance-charms',
    charms:[['music','Music & Dance','music-dance-charms'],['books','Book Lovers','reading-charms'],['spooky','Spooky & Gothic','spooky-gothic-charms'],['mythical','Mythical & Fantasy','mythical-fantasy-charms']]}
];
const esc = s => String(s).replace(/[&<>"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
const pickObj = () => S.door==='dog' ? DOG.find(x=>x.id===S.pick) : S.door==='cat' ? CAT.find(x=>x.id===S.pick) : PASS.find(x=>x.id===S.pick);
const skipped = () => false;
function dots(){
  const total = skipped() ? 3 : 4;
  let idx = S.step==='door' ? 0 : (S.step==='reveal' ? total-2 : (S.step==='sms' ? total-1 : (skipped()?0:1)));
  let h = ''; for(let i=0;i<total;i++) h += `<i class="${i===idx?'on':''}"></i>`;
  return `<div class="dots" aria-label="Step ${idx+1} of ${total}">${h}<span>Step ${idx+1} of ${total}</span></div>`;
}
const closeBtn = () => `<button class="close" data-act="close" aria-label="Close"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#24184A" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>`;
const allBtn = () => `<button class="backlink" data-act="door">${BACK}All options</button>`;
const decoPick = () => `<div class="deco" aria-hidden="true">
  <svg class="spin" width="150" height="150" viewBox="0 0 100 100" style="position:absolute;left:-48px;top:-48px;color:#FFD45C">${STAR}</svg>
  <svg width="62" height="62" viewBox="0 0 64 64" style="position:absolute;right:64px;bottom:22px;transform:rotate(18deg)">${PAW('#C3B6FF')}</svg>
  <div style="position:absolute;right:-30px;top:120px;width:90px;height:90px;border-radius:50%;background:#7FDCC4;opacity:.45"></div></div>`;

function vDoor(){
  const m = S.view==='m';
  const cards = DOOR.map(d => {
    const art = d.imgs.length>1
      ? `<div class="fan">${d.imgs.map(k=>`<img src="${IMG[k]}" alt="" style="height:${m?64:96}px">`).join('')}</div>`
      : `<img class="live a-${d.imgs[0]}" src="${IMG[d.imgs[0]]}" alt="" style="max-height:${m?96:170}px">`;
    return `<button class="card" data-act="door-${d.id}" style="background:${d.color}">
      ${d.tag?`<span class="tag">${d.tag}</span>`:''}
      <div class="halo" style="top:${m?0:26}px;width:170px;height:170px"></div>
      <div class="art">${art}</div>
      <div class="txt"><div class="nm">${esc(d.name)}</div><div class="cp">${esc(d.cap)}</div></div></button>`;
  }).join('');
  return `${decoPick()}<div class="pane">
    <div class="toprow"><span class="badge"><svg width="16" height="16" viewBox="0 0 64 64" aria-hidden="true">${PAW('#FFD45C')}</svg>Welcome gift inside</span></div>
    <h1 class="disp">Who's your <span class="hl">little soul?</span></h1>
    <p class="sub">Pick one. We'll match you with charms and an extra 10% off.</p>
    <div class="grid g-door">${cards}</div>
    <div style="display:flex;justify-content:space-between;align-items:center;width:100%;margin-top:auto;padding-top:14px;gap:10px">${dots()}<button class="skip" style="margin:0;padding:0" data-act="close">No thanks, I'll pay full price</button></div>
  </div>`;
}
function vPoses(kind){
  const m = S.view==='m', list = kind==='dog'?DOG:CAT;
  const hImg = kind==='dog' ? (m?124:166) : (m?150:190);
  const cards = list.map(p => `<button class="card" data-act="pick-${p.id}" style="background:${p.color}" aria-label="${esc(p.name)}: ${esc(p.cap)}">
    <div class="halo" style="top:${m?16:22}px;width:${m?124:170}px;height:${m?124:170}px"></div>
    <div class="art"><img class="live a-${p.id}" src="${IMG[p.id]}" alt="${esc(p.product)} charm" style="max-height:${hImg}px"></div>
    <div class="nm">${esc(p.name)}</div><div class="cp">${esc(p.cap)}</div></button>`).join('');
  const h = kind==='dog' ? `Every dog has a <span class="hl">signature move.</span>` : `Every cat has an <span class="hl">attitude.</span>`;
  const sub = kind==='dog' ? 'Which one is yours? Tap your pup to unlock your gift.' : 'Which one lives with you? Tap your cat to unlock your gift.';
  return `${decoPick()}${allBtn()}<div class="pane">
    <div class="toprow">${dots()}</div>
    <h1 class="disp">${h}</h1><p class="sub">${sub}</p>
    <div class="grid g-${kind}">${cards}</div>
    <button class="skip" data-act="close">No thanks, I'll pay full price</button></div>`;
}
function vPass(){
  const m = S.view==='m', pre = null;
  const cards = PASS.map(c => `<button class="card${pre===c.id?' pre':''}" data-act="pick-${c.id}" style="background:${c.color}">
    ${pre===c.id?'<span class="tag">For you</span>':''}
    <div class="art"><div class="fan">${c.charms.slice(0,3).map(([k])=>`<img src="${IMG[k]}" alt="" style="height:${m?54:66}px">`).join('')}</div></div>
    <div class="nm">${esc(c.name)}</div><div class="cp">${esc(c.cap)}</div></button>`).join('');
  return `${decoPick()}${allBtn()}<div class="pane">
    <div class="toprow">${dots()}</div>
    <h1 class="disp">What makes you, <span class="hl">you?</span></h1>
    <p class="sub">Pick what sounds most like you (or who you're shopping for).</p>
    <div class="grid g-pass">${cards}</div>
    <button class="skip" data-act="close">No thanks, I'll pay full price</button></div>`;
}
function showPanel(o){
  const m = S.view==='m';
  if (S.door==='passion'){
    const W = m?358:360, H = m?230:560, ih = m?66:100;
    const rows = m ? [[0,1,2,3]] : [[0,1],[2,3]];
    const cys = m ? [36] : [92, 300], sag = m?22:30;
    let paths = '', hang = '';
    rows.forEach((row, r) => {
      const cy = cys[r], n = row.length, gap = W/(n+1);
      paths += `<path d="M0 ${cy} Q ${W/2} ${cy+sag*2} ${W} ${cy}" fill="none" stroke="#24184A" stroke-width="3" stroke-linecap="round"/>`;
      row.forEach((ci, i) => {
        const [k,label] = o.charms[ci], x = gap*(i+1), t = x/W, y = cy + 4*sag*t*(1-t);
        hang += `<div class="hang" style="left:${x-gap/2}px;top:${y-ih*.1}px;width:${gap}px;animation-delay:${.08+ci*.12}s">
          <img src="${IMG[k]}" alt="${esc(label)} charm" style="height:${ih}px;max-width:${m?gap-6:gap-20}px;animation-delay:${ci*.3}s">${m?'':`<span>${esc(label)}</span>`}</div>`;
      });
    });
    return `<div class="show" style="background:${o.color}">
      <svg class="burst spin" width="${m?300:440}" height="${m?300:440}" viewBox="0 0 100 100" aria-hidden="true">${STAR}</svg>
      <svg class="cord" viewBox="0 0 ${W} ${H}" preserveAspectRatio="none" aria-hidden="true">${paths}</svg>
      ${hang}
      <div class="prodtag">${esc(o.name)} · ${o.charms.length} picks for you</div></div>`;
  }
  return `<div class="show" style="background:${o.color}">
    <svg class="burst spin" width="${m?300:420}" height="${m?300:420}" viewBox="0 0 100 100" aria-hidden="true">${STAR}</svg>
    <div class="popin"><img class="hero live a-${o.id}" src="${IMG[o.id]}" alt="${esc(o.product)} charm" style="max-width:${m?200:250}px;max-height:${m?170:270}px"></div>
    <div class="bubble disp" style="top:${m?24:78}px;right:${m?22:28}px">${esc(o.bubble)}</div>
    <div class="prodtag">${esc(o.product)} charm · from $35</div></div>`;
}
function vReveal(){
  const o = pickObj(), title = S.door==='passion' ? o.result : o.name;
  const eyebrow = S.door==='dog' ? 'Called it. Your pup is…' : S.door==='cat' ? 'Called it. Your cat is…' : 'Called it. You are…';
  return `${allBtn()}<div class="split">${showPanel(o)}
  <form class="body" data-email-form novalidate>
    ${dots()}
    <div class="eyebrow">${eyebrow}</div>
    <h2 class="disp">${esc(title)}</h2>
    <p>${esc(o.verdict)} Your <strong>extra 10% off</strong> is ready. Where should we send it?</p>
    <div class="field"><label for="pp-email">Email address</label>
      <input id="pp-email" type="email" autocomplete="email" placeholder="you@example.com" value="${esc(S.email)}" aria-invalid="${S.err}" aria-describedby="pp-err">
      ${S.err?`<div class="err" id="pp-err">${esc(S.err)}</div>`:''}</div>
    <div class="chips" role="group" aria-label="Shopping for"><span>Shopping for</span>
      <button type="button" class="chip" data-act="who-me" aria-pressed="${S.who==='me'}">Myself</button>
      <button type="button" class="chip" data-act="who-gift" aria-pressed="${S.who==='gift'}">A loved one</button></div>
    <button type="submit" class="cta" ${S.submitting?'disabled aria-busy="true"':''}>${S.submitting?'Sending…':'Send my 10% off'} ${ARROW}</button>
    <div class="fine"><span>You agree to receive marketing emails. Unsubscribe anytime.</span><button type="button" class="link" data-act="back">Pick again</button></div>
  </form></div>`;
}
function vSms(){
  const o = pickObj();
  return `<div class="split">${showPanel(o)}
  <form class="body sms-body" data-sms-form novalidate>
    ${dots()}
    <div class="eyebrow">Your 10% welcome code is on its way</div>
    <h2 class="disp">Want one more gift?</h2>
    <p>We sent the 10% welcome code to <strong>${esc(S.email)}</strong>. Joining our Pack Line by text is totally optional.</p>
    <div class="sms-offer">
      <div class="sms-eyebrow">TEXT-ONLY EXTRA</div>
      <h3>FREE 1 charm back engraving</h3>
      <p>We'll text you a private code for your first piece. Add their name, a date or a little note on the back.</p>
      <div class="sms-math"><span>10% welcome code</span><b>+</b><span>Free $5 engraving</span></div>
      <div class="sms-combine">= both on one order</div>
    </div>
    <div class="field"><label for="pp-phone">Mobile number (US +1)</label>
      <input id="pp-phone" type="tel" inputmode="tel" autocomplete="tel" placeholder="(555) 123-4567" value="${esc(S.phone)}" aria-invalid="${S.phoneErr}">
      ${S.phoneErr?`<div class="err">${esc(typeof S.phoneErr==='string'?S.phoneErr:'Enter a valid 10-digit US mobile number.')}</div>`:''}</div>
    <button type="submit" class="cta" ${S.submitting?'disabled aria-busy="true"':''}>${S.submitting?'SUBMITTING…':'TEXT ME MY CODE'} ${ARROW}</button>
    <div class="sms-trust"><span>Just a few texts a month</span><span>No late-night texts</span><span>We never sell or share your number</span><span>Text STOP to leave anytime</span></div>
    <button type="button" class="sms-skip" data-act="sms-skip">No thanks, email's enough</button>
    <div class="sms-disclosure">By tapping “Text me my code,” you agree to receive recurring automated marketing text messages (e.g. cart reminders, exclusive offers) from Soulyshine at the number provided. Consent is not a condition of purchase. Msg &amp; data rates may apply. Msg frequency varies. Reply HELP for help or STOP to cancel. See our <a href="${SITE}/policies/privacy-policy" data-result-link>Privacy Policy</a> and <a href="${SITE}/policies/terms-of-service" data-result-link>Terms</a>.</div>
  </form></div>`;
}
function vGift(){
  const o = pickObj(), pet = S.door!=='passion';
  const ctaUrl = pet ? o.url : SITE+'/collections/'+o.handle;
  const welcomeUrl = SITE+'/discount/WELCOME10?redirect='+encodeURIComponent(ctaUrl.replace(SITE,''));
  const tip = S.smsOptIn ? 'Your engraving code comes by text after you reply Y. Your 10% welcome code is also in your inbox.' : 'No code to copy here. Use the button and we will apply your 10% automatically.';
  const niches = pet ? '' : `<div class="niche">${o.charms.map(([k,label,q])=>`<a href="${SITE}/collections/${q}" data-result-link>${esc(label)}</a>`).join('')}</div>`;
  return `<div class="split">${showPanel(o)}
  <div class="body">
    <div class="eyebrow">${S.smsOptIn?'Almost there':'Welcome to the pack'}</div>
    <h2 class="disp">${S.smsOptIn?'Check your texts':'Your 10% is on its way'}</h2>
    <p>${S.smsOptIn?'Reply <strong>Y</strong> to confirm. Your private $5 charm engraving code will arrive right after.':'We sent your 10% welcome code to your email. Or use the button below and we will apply it automatically.'}</p>
    <div class="email-confirm"><span class="check">✓</span><span><b>10% code emailed for later use</b>Save it for whenever you're ready · ${esc(S.email)}</span></div>
    ${S.smsOptIn?'<div class="success-steps"><span><b>1 · Reply Y</b>Confirm your text opt-in</span><span><b>2 · Get your code</b>Unique ENGRAVE-xxx</span><span><b>3 · Use in 7 days</b>One free $5 engraving</span></div>':''}
    <a class="cta" href="${welcomeUrl}" data-result-link>SHOP NOW · 10% AUTO-APPLIED ${ARROW}</a>
    ${niches}
    <div class="foot"><svg width="22" height="22" viewBox="0 0 64 64" aria-hidden="true" style="flex:none">${PAW('#24184A')}</svg><span>${tip}</span></div>
  </div></div>`;
}



  var scaler = root.querySelector('[data-popup-scaler]');
  var fit = root.querySelector('[data-popup-fit]');
  var DAY = 24 * 60 * 60 * 1000;
  var TWO_DAYS = 48 * 60 * 60 * 1000;
  var DISMISS_KEY = 'ss_pup_quiz_dismissed_until';
  var OPTED_KEY = 'ss_pup_quiz_opted_in';
  var MANUAL_OPEN_PARAM = 'soulyshine_pup_quiz';
  var lastFocused = null;
  var manualOpenRequested = false;
  var eligibilityPromise;
  var hasTrackedOpen = false;
  var resizeTimer = 0;

  try { manualOpenRequested = new URLSearchParams(window.location.search).get(MANUAL_OPEN_PARAM) === 'open'; } catch (e) {}

  function storageGet(key) { try { return window.localStorage.getItem(key); } catch (e) { return null; } }
  function storageSet(key, value) { try { window.localStorage.setItem(key, value); } catch (e) {} }
  function setCookie(name, value, seconds) { document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + seconds + '; SameSite=Lax'; }
  function getCookie(name) {
    var prefix = name + '=';
    var parts = document.cookie ? document.cookie.split('; ') : [];
    for (var i = 0; i < parts.length; i += 1) if (parts[i].indexOf(prefix) === 0) return decodeURIComponent(parts[i].slice(prefix.length));
    return null;
  }
  function dismissedUntil() { return Number(storageGet(DISMISS_KEY) || getCookie(DISMISS_KEY) || 0); }
  function alreadyOptedIn() { return storageGet(OPTED_KEY) === '1' || getCookie(OPTED_KEY) === '1'; }
  function isEligibleNow() { return !S.optedIn && !alreadyOptedIn() && dismissedUntil() <= Date.now(); }
  function withTimeout(promise, ms, fallback) {
    return Promise.race([promise, new Promise(function (resolve) { window.setTimeout(function () { resolve(fallback); }, ms); })]);
  }
  function isKnownKlaviyoProfile() {
    if (root.dataset.customerKnown === 'true') return Promise.resolve(true);
    return new Promise(function (resolve) {
      var deadline = Date.now() + 2500;
      function check() {
        if (window.klaviyo && typeof window.klaviyo.isIdentified === 'function') {
          try {
            withTimeout(Promise.resolve(window.klaviyo.isIdentified()), 1200, false)
              .then(function (known) { resolve(Boolean(known)); })
              .catch(function () { resolve(false); });
          } catch (e) { resolve(false); }
        } else if (Date.now() >= deadline) resolve(false);
        else window.setTimeout(check, 100);
      }
      check();
    });
  }
  function currentPick() { return S.pick ? pickObj() : null; }
  function segmentName() { return S.door === 'dog' ? 'Dog' : S.door === 'cat' ? 'Cat' : 'People & Passions'; }
  function track(name, extra) {
    var payload = Object.assign({
      'Popup Version': 'Three-Door v1',
      'Source Page': root.dataset.sourcePath || window.location.pathname,
      'Page Type': root.dataset.pageType || '',
      'Welcome Segment': S.door ? segmentName() : '',
      'Welcome Pick': currentPick() ? currentPick().name : ''
    }, extra || {});
    try {
      if (window.klaviyo && typeof window.klaviyo.push === 'function') window.klaviyo.push(['track', name, payload]);
      else if (window._learnq && typeof window._learnq.push === 'function') window._learnq.push(['track', name, payload]);
    } catch (e) {}
  }
  function captureEmail() {
    var input = scaler.querySelector('#pp-email');
    if (input) S.email = input.value.trim();
  }
  function capturePhone() {
    var input = scaler.querySelector('#pp-phone');
    if (input) S.phone = input.value.trim();
  }
  function hideTeaser() { teaser.hidden = true; teaser.setAttribute('aria-expanded', 'false'); }
  function showTeaser() {
    if (S.optedIn || alreadyOptedIn() || root.dataset.suppressed === 'known-profile') return;
    teaser.hidden = false;
    teaser.setAttribute('aria-expanded', 'false');
  }
  function clearManualOpenRequest() {
    if (!manualOpenRequested || !window.history || typeof window.history.replaceState !== 'function') return;
    try {
      var cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete(MANUAL_OPEN_PARAM);
      window.history.replaceState({}, document.title, cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
    } catch (e) {}
    manualOpenRequested = false;
  }
  function layout() {
    if (root.hidden || !scaler.firstElementChild) return;
    scaler.style.transform = 'none';
    var popup = scaler.firstElementChild;
    var availW = Math.max(280, window.innerWidth - (S.view === 'm' ? 16 : 32));
    var viewportH = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    var availH = Math.max(360, viewportH - (S.view === 'm' ? 16 : 32));
    var w = popup.offsetWidth;
    var h = popup.offsetHeight;
    var scale = Math.min(1, availW / w, availH / h);
    scaler.style.transform = 'scale(' + scale + ')';
    fit.style.width = (w * scale) + 'px';
    fit.style.height = (h * scale) + 'px';
  }
  function render() {
    var inner = S.step === 'door' ? vDoor() : S.step === 'dog' ? vPoses('dog') : S.step === 'cat' ? vPoses('cat') : S.step === 'passion' ? vPass() : S.step === 'reveal' ? vReveal() : S.step === 'sms' ? vSms() : vGift();
    scaler.innerHTML = '<div class="pp ' + S.view + '" role="dialog" aria-modal="true" aria-label="Soulyshine welcome gift">' + closeBtn() + inner + '</div>';
    window.requestAnimationFrame(layout);
    tick();
  }
  function focusFirst() {
    window.setTimeout(function () {
      var target = scaler.querySelector('#pp-email, .pp button, .pp a');
      if (target) target.focus({ preventScroll: true });
    }, 40);
  }
  function openPopup(ignoreDismissal) {
    if (S.optedIn || alreadyOptedIn() || (!ignoreDismissal && !isEligibleNow()) || !root.hidden) return;
    lastFocused = document.activeElement;
    hideTeaser();
    root.hidden = false;
    teaser.setAttribute('aria-expanded', 'true');
    document.body.classList.add('ss-pup-is-open');
    render();
    focusFirst();
    if (!hasTrackedOpen) { track('Viewed Soulyshine Welcome Popup'); hasTrackedOpen = true; }
  }
  function closePopup() {
    if (root.hidden) return;
    captureEmail();
    root.hidden = true;
    document.body.classList.remove('ss-pup-is-open');
    if (!S.optedIn) {
      var until = Date.now() + DAY;
      storageSet(DISMISS_KEY, String(until));
      setCookie(DISMISS_KEY, String(until), 86400);
      showTeaser();
      track('Dismissed Soulyshine Welcome Popup', { 'Dismissed At Step': S.step });
    }
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus({ preventScroll: true });
  }
  function go(step) { captureEmail(); S.step = step; render(); focusFirst(); }
  function validEmail(value) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value); }
  function subscriptionPayload(email) {
    var selected = currentPick();
    var properties = {
      'Welcome Segment': segmentName(),
      'Welcome Pick': selected ? selected.name : '',
      'Welcome Result': selected ? (S.door === 'passion' ? selected.result : selected.name) : '',
      'Shopping For': S.who === 'gift' ? 'A loved one' : 'Myself',
      'Welcome Offer': 'WELCOME10',
      'Welcome Source Page': root.dataset.sourcePath || window.location.pathname,
      'Welcome Page Type': root.dataset.pageType || ''
    };
    if (S.door === 'dog' && selected) properties['Pup Personality'] = selected.name;
    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Soulyshine Three-Door Welcome Popup',
          profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }, properties: properties } } }
        },
        relationships: { list: { data: { type: 'list', id: root.dataset.listId } } }
      }
    };
  }
  function identify(email) {
    var selected = currentPick();
    var props = {
      email: email,
      'Welcome Segment': segmentName(),
      'Welcome Pick': selected ? selected.name : '',
      'Welcome Result': selected ? (S.door === 'passion' ? selected.result : selected.name) : '',
      'Shopping For': S.who === 'gift' ? 'A loved one' : 'Myself',
      'Welcome Offer': 'WELCOME10',
      'Welcome Source Page': root.dataset.sourcePath || window.location.pathname
    };
    if (S.door === 'dog' && selected) props['Pup Personality'] = selected.name;
    try {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify(props);
      else if (window._learnq && typeof window._learnq.push === 'function') window._learnq.push(['identify', props]);
    } catch (e) {}
  }
  function submitSubscription(event) {
    event.preventDefault();
    var input = scaler.querySelector('#pp-email');
    S.email = input ? input.value.trim() : '';
    S.err = '';
    if (!validEmail(S.email)) {
      S.err = 'Please enter a valid email address.';
      render();
      var invalid = scaler.querySelector('#pp-email');
      if (invalid) invalid.focus();
      return;
    }
    if (S.submitting) return;
    S.submitting = true;
    render();
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(root.dataset.companyId), {
      method: 'POST',
      headers: { accept: 'application/vnd.api+json', 'content-type': 'application/vnd.api+json', revision: '2026-07-15' },
      body: JSON.stringify(subscriptionPayload(S.email))
    }).then(function (response) {
      if (!response.ok) throw new Error('Klaviyo subscription failed: ' + response.status);
      S.submitting = false;
      S.code = 'WELCOME10';
      S.step = 'sms';
      hideTeaser();
      storageSet(OPTED_KEY, '1');
      setCookie(OPTED_KEY, '1', 31536000);
      storageSet(DISMISS_KEY, '0');
      setCookie(DISMISS_KEY, '0', 0);
      identify(S.email);
      track('Submitted Soulyshine Welcome Popup', { 'Email': S.email, 'Coupon': 'WELCOME10' });
      render();
    }).catch(function () {
      S.submitting = false;
      S.err = 'We could not save your email. Please try again.';
      render();
      var failed = scaler.querySelector('#pp-email');
      if (failed) failed.focus();
    });
  }
  function smsSubscriptionPayload(phoneNumber) {
    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Soulyshine Three-Door Popup SMS',
          profile: { data: { type: 'profile', attributes: {
            email: S.email,
            phone_number: phoneNumber,
            subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } },
            properties: {
              'SMS Source': 'Three-Door Popup',
              'SMS Offer': '$5 Charm Back Engraving',
              'Welcome Offer': 'WELCOME10'
            }
          } } }
        },
        relationships: { list: { data: { type: 'list', id: root.dataset.smsListId } } }
      }
    };
  }
  function submitSms(event) {
    event.preventDefault();
    capturePhone();
    var digits = String(S.phone || '').replace(/D/g, '').replace(/^1(?=d{10}$)/, '');
    S.phoneErr = '';
    if (digits.length !== 10) {
      S.phoneErr = 'Enter a valid 10-digit US mobile number.';
      render();
      var invalid = scaler.querySelector('#pp-phone');
      if (invalid) invalid.focus();
      return;
    }
    if (S.submitting) return;
    S.phone = '+1' + digits;
    S.submitting = true;
    render();
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(root.dataset.companyId), {
      method: 'POST',
      headers: { accept: 'application/vnd.api+json', 'content-type': 'application/vnd.api+json', revision: '2026-07-15' },
      body: JSON.stringify(smsSubscriptionPayload(S.phone))
    }).then(function (response) {
      if (!response.ok) throw new Error('Klaviyo SMS subscription failed: ' + response.status);
      S.submitting = false;
      S.smsOptIn = true;
      S.step = 'gift';
      track('Submitted Soulyshine SMS Opt-In', { 'Email': S.email, 'Phone Last 4': S.phone.slice(-4), 'SMS List': root.dataset.smsListId });
      render();
    }).catch(function () {
      S.submitting = false;
      S.phoneErr = 'We could not save your number. Please try again.';
      render();
      var failed = scaler.querySelector('#pp-phone');
      if (failed) failed.focus();
    });
  }
  function tick() {
    var timer = scaler.querySelector('#pp-timer');
    if (!timer || !S.expiresAt) return;
    var left = Math.max(0, S.expiresAt - Date.now());
    function pad(n) { return String(n).padStart(2, '0'); }
    timer.textContent = pad(Math.floor(left / 3600000)) + ':' + pad(Math.floor(left / 60000) % 60) + ':' + pad(Math.floor(left / 1000) % 60);
  }
  window.setInterval(tick, 1000);

  scaler.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('[data-act]') : null;
    if (!button) return;
    var action = button.dataset.act;
    if (action.indexOf('door-') === 0) {
      S.door = action.slice(5); S.pick = null;
      track('Selected Soulyshine Welcome Segment', { 'Welcome Segment': segmentName() });
      go(S.door === 'passion' ? 'passion' : S.door); return;
    }
    if (action === 'door') { S.door = null; S.pick = null; go('door'); return; }
    if (action.indexOf('pick-') === 0) {
      S.pick = action.slice(5); S.err = '';
      track('Selected Soulyshine Welcome Pick'); go('reveal'); return;
    }
    if (action === 'who-me' || action === 'who-gift') { S.who = action === 'who-me' ? 'me' : 'gift'; render(); return; }
    if (action === 'back') { S.pick = null; S.err = ''; go(S.door === 'passion' ? 'passion' : S.door); return; }
    if (action === 'sms-skip') { S.smsOptIn = false; S.step = 'gift'; render(); return; }
    if (action === 'close') { closePopup(); return; }
    if (action === 'copy') {
      try { if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText('WELCOME10').catch(function () {}); } catch (e) {}
      S.copied = true; render(); return;
    }
  });
  scaler.addEventListener('submit', function (event) {
    if (event.target && event.target.matches('[data-sms-form]')) submitSms(event);
    else submitSubscription(event);
  });
  scaler.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('[data-result-link]') : null;
    if (link) track('Clicked Soulyshine Welcome Result', { 'Destination': link.href || '' });
  });
  teaser.addEventListener('click', function () { openPopup(true); });
  root.addEventListener('keydown', function (event) { if (event.key === 'Escape') closePopup(); });
  root.addEventListener('click', function (event) { if (event.target.classList.contains('ss-three-door__overlay')) closePopup(); });
  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      var next = window.innerWidth < 720 ? 'm' : 'd';
      if (next !== S.view) { captureEmail(); S.view = next; if (!root.hidden) render(); }
      else layout();
    }, 120);
  });

  eligibilityPromise = isKnownKlaviyoProfile().then(function (known) {
    if (known) { root.dataset.suppressed = 'known-profile'; hideTeaser(); }
    else if (manualOpenRequested) { openPopup(true); clearManualOpenRequest(); }
    else if (dismissedUntil() > Date.now() && !alreadyOptedIn()) showTeaser();
    return !known;
  });
  window.setTimeout(function () { eligibilityPromise.then(function (eligible) { if (eligible) openPopup(false); }); }, 3000);
  document.addEventListener('mouseout', function (event) {
    if (event.relatedTarget || event.toElement || event.clientY > 8) return;
    eligibilityPromise.then(function (eligible) { if (eligible) openPopup(false); });
  });

})();
